var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#EEECEE",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.8975 -0.061875 3.795 -0.12375 5.75 -0.1875 C7.35101563 -0.23970703 7.35101563 -0.23970703 8.984375 -0.29296875 C12.34503863 0.03352059 13.67828434 0.57854477 16 3 C16.42751128 6.42009021 16.60318593 8.83132725 15 11.9375 C11.73357754 13.67278693 8.65648548 13.17982715 5 13 C5 15.64 5 18.28 5 21 C3.35 21 1.7 21 0 21 C0 14.07 0 7.14 0 0 Z ",
    fill: "#D024B9",
    transform: "translate(9,5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.515625 0.37125 1.03125 0.7425 1.5625 1.125 C1.92817164 7.585199 1.92817164 7.585199 0.25 10.0625 C-1.4375 11.125 -1.4375 11.125 -4.4375 11.125 C-4.7675 10.135 -5.0975 9.145 -5.4375 8.125 C-4.7775 7.795 -4.1175 7.465 -3.4375 7.125 C-3.4375 5.805 -3.4375 4.485 -3.4375 3.125 C-6.4075 2.63 -6.4075 2.63 -9.4375 2.125 C-9.4375 1.795 -9.4375 1.465 -9.4375 1.125 C-3.0375 -1.09038462 -3.0375 -1.09038462 0 0 Z ",
    fill: "#CD17B6",
    transform: "translate(23.4375,6.875)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 1.65 6.66 3.3 7 5 C4 7 4 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#F7DCF4",
    transform: "translate(14,9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartIcon);
export default __webpack_public_path__ + "static/media/part-icon.d85732b4bbb5097f6478bfa1cecf1ea1.svg";
export { ForwardRef as ReactComponent };